export default "__VITE_ASSET__DlWjbjPo__"